<template>
    <header class="view-header">
        <div class="container" v-if="hasTitleSlot">
            <h1 class="view-header__title">
                <slot name="title"></slot>
            </h1>
            <div class="view-header__intro">
                <slot name="intro"></slot>
            </div>
        </div>

        <div v-else>
            <slot name="content"></slot>
        </div>
    </header>
</template>


<script>
    export default {
        computed: {
            hasTitleSlot() {
                return !!this.$slots.title
            }
        }
    }
</script>
